import React, { useEffect, useContext } from 'react';
import { GlobalContext } from '../contexts/GlobalContext';
import { Link, useNavigate } from 'react-router-dom';

function LogOut() {
  const { setIsLoggedIn, setUserLevel } = useContext(GlobalContext);
  const navigate = useNavigate();

  useEffect(() => {
    const logout = async () => {
      try {
        await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/logout`, {
          method: 'POST',
          credentials: 'include',
        });
        // Update context to reflect that the user is logged out
        setIsLoggedIn(false);
        setUserLevel('3'); // Reset to default level for non-logged-in users
        localStorage.removeItem('isLoggedIn');
        localStorage.removeItem('userLevel');
        // Optionally, you can navigate to a different page
        // navigate('/login');
      } catch (error) {
        console.error('Error during logout:', error);
      }
    };

    logout();
  }, [setIsLoggedIn, setUserLevel]);

  return (
    <div className="page-content">
        <h2>您已成功登出</h2>
        <Link to="/login">
            <button className="button button-m">
                會員登入
            </button>
        </Link>

        <button onClick={() => navigate('/')} className="button button-m">
            返回首頁
        </button>
    </div>
  );
}

export default LogOut;
